import { createActions, createReducer } from 'reduxsauce';
import listaBases from 'Dados/Bases';
export const { Types, Creators } = createActions({
	criarEmpresa: [ 'payload' ],
	adicionarBase: [ 'payload' ],
	adicionarBaseSuces: [ 'payload' ],
	listaBases: [ 'payload' ],
	listaBaseSuces: [ 'payload' ],
	editarEmpresa: [ 'payload' ],
	removeBase: [ 'payload' ],
	removeBaseSuces: [ 'payload' ],
	setLoad: [ 'payload' ],
	setLoadAction: [ 'payload' ]
});

const INIT_STATE = {
	newBases: [],
	lista: [],
	loading: false,
	loadingAction: false
}

const setLoad = (state = INIT_STATE, action) => ({
	...state,
	loading: action.payload.exibir
})

const setLoadAction = (state = INIT_STATE, action) => ({
	...state,
	loadingAction: action.payload.exibir
})

const adicionarBaseSuces = (state = INIT_STATE, action) => {
	const base = action.payload;
	let newBase = []
	const lista = state.lista

	lista.length != 0 ?
		Object.keys(base).map((item) => {
			newBase.push( 
				{
					base: item,
					cnpj_empresa: base[item].cnpj,
					endereco: base[item].endereco,
					telefone: base[item].telefone,
				}
			)
		}) : Object.keys(base).map((item) => {
			lista.unshift(
				newBase = {
					base: item,
					cnpj_empresa: base[item].cnpj,
					endereco: base[item].endereco,
					telefone: base[item].telefone,
				}
			)
		})
				
	const newLista = [ ...newBase, ...lista ]
	return {
		...state,
		lista: newLista
	}
}

const listaBaseSuces = (state = INIT_STATE, action) => {
	const lista = action.payload;
	
	return {
		...state,
		loading: false,
		lista: lista.valor
	};
}

const removeBaseSuces = (state = INIT_STATE, action) => {
	const { index } = action.payload;
	let lista = state.lista;
	const newLista = lista.filter((item, i) => item.base != index);

	return {
		...state,
		lista: newLista
	}
}
export default createReducer(INIT_STATE, {
	[Types.ADICIONAR_BASE_SUCES]: adicionarBaseSuces,
	[Types.LISTA_BASE_SUCES]: listaBaseSuces,
	[Types.REMOVE_BASE_SUCES]: removeBaseSuces,
	[Types.SET_LOAD]: setLoad,
	[Types.SET_LOAD_ACTION]: setLoadAction
});

